'use client';

import classNames from 'classnames';
import { ComponentProps } from 'react';
import Image from '@alltrails/core/components/Image';
import { BREAKPOINT_LG_MARGIN, BREAKPOINT_LG_SIZE, BREAKPOINT_MD_MARGIN, BREAKPOINT_MD_SIZE, BREAKPOINT_SM_SIZE } from '@alltrails/denali/tokens';
import styles from './HeroImage.module.scss';

const getImageSize = (screenSize: number, smallGridImage: boolean) => (smallGridImage ? screenSize / 3 : screenSize);

type HeroImageProps = {
  alt?: string;
  handleLoadingState?: ComponentProps<typeof Image>['handleLoadingState'];
  isLcp?: boolean;
  loading?: ComponentProps<typeof Image>['loading'];
  photoUrl: string;
  priority?: ComponentProps<typeof Image>['priority'];
  className?: string;
  quality?: number;
  smallGridImage?: boolean;
};

const HeroImage = ({
  alt,
  handleLoadingState,
  isLcp,
  loading,
  photoUrl,
  priority,
  className,
  quality = 90,
  smallGridImage = false
}: HeroImageProps) => {
  return (
    <Image
      alt={alt || ''}
      className={classNames(styles.hero, className)}
      fill
      handleLoadingState={handleLoadingState}
      isLcp={isLcp}
      loading={loading}
      priority={priority}
      quality={quality}
      sizes={`(max-width: ${BREAKPOINT_SM_SIZE}px) 100vw, (max-width: ${BREAKPOINT_MD_SIZE}px) ${getImageSize(
        BREAKPOINT_MD_SIZE - BREAKPOINT_MD_MARGIN * 2,
        smallGridImage
      )}px, (max-width: ${BREAKPOINT_LG_SIZE}px) ${getImageSize(BREAKPOINT_LG_SIZE - BREAKPOINT_LG_MARGIN * 2, smallGridImage)}px, ${getImageSize(
        BREAKPOINT_LG_SIZE - BREAKPOINT_LG_MARGIN * 2,
        smallGridImage
      )}px`}
      src={photoUrl}
      style={{ transition: 'all 0.3s ease-in-out' }}
      title={alt}
    />
  );
};

export default HeroImage;
